import { defineStore } from "pinia";
import { getMenuListApi } from "@/api/user";
import { RouterPathComponent } from "@/utils/constant";
import { ElLoading } from "element-plus";
import { layoutRoutes } from "@/router.js";

export const usePermissionRouterStore = defineStore("permissionRouter", {
  state: () => {
    return {
      permissionRouter: [],
      isLoading: false,
    };
  },
  actions: {
    /**
     * 获取前端项目中写的菜单路由
     * */
    getConstantMenuList() {
      console.log("layoutRoutes  ", layoutRoutes);
      const menuList =
        layoutRoutes
          ?.find((elm) => elm.name === "home" && elm.path === "/")
          ?.children?.filter((elm) => elm.meta?.menu) || [];

      this.permissionRouter = this.permissionRouter.concat(menuList);
    },
    setPermissionRouter(data) {
      this.permissionRouter = data;
    },
    async initPermissionRouter(router) {
      if (this.isLoading) return; // 防止重复加载
      this.isLoading = true;

      const loading = ElLoading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        let params = {};
        const res = await getMenuListApi(params);
        if (res?.code == 20000) {
          this.permissionRouter = [];
          res.data?.list?.forEach((elm) => {
            if (RouterPathComponent[elm.path]) {
              try {
                const component = RouterPathComponent[elm.path];
                const routerItem = {
                  path: `/${elm.path}`,
                  name: elm.path,
                  component: component,
                  meta: {
                    ...elm,
                    title: elm.title,
                    icon: elm.icon,
                  },
                };
                router.addRoute("home", routerItem);
                this.permissionRouter.push(routerItem);
              } catch (componentError) {
                console.error(
                  `Failed to load component for path: ${elm.path}`,
                  componentError
                );
                this.isLoading = false; // 停止加载
                loading.close();
                throw new Error(
                  `Failed to load component for path: ${elm.path}`
                );
              }
            } else {
              console.warn(`Component not found for path: ${elm.path}`);
            }
          });
          this.getConstantMenuList();
          console.log("添加完成了 ", router);
          return true;
        }
      } catch (error) {
        console.log("报错了", error);
      } finally {
        loading.close();
        this.isLoading = false; // 确保在所有情况下都重置加载状态
        console.log("执行了关闭 ");
      }
    },
  },
});
